import { maybeLog } from '../utils';

/**
 * Intended to be triggered when a user visits the webapp. Used to handle
 * some app/state initialization.
 */
export async function startup( { debug } ) {
    maybeLog( debug, 'Starting React application...' );
    // ...
}
